<template>
  <div
    class="sai-list-content"
    ref="saiListContent"
  >
    <ul class="sai-list-content__lists">
      <FaqItem
        v-for="(item, index) in list"
        v-if="item"
        :key="item.talkScriptId"
        :item="item"
        :index="index"
        :action="'frequent'"
      />
    </ul>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component';
import { AsyncComputed } from '@/libs/vue-async-computed-decorator';
import ListContentWrapperMixin from '@/mixins/ListContentWrapperMixin';
import frequent from '@/common/frequent';

@Component({
  components: {},
  props: {},
})
export default class Frequent extends mixins(ListContentWrapperMixin) {
  faqList = [];
  async created() {
    this.faqList = await frequent.getFaqList(process.env.INITIAL_FAQ_FILE);
  }
  @AsyncComputed()
  list() {
    return this.faqList;
  }
}
</script>



// WEBPACK FOOTER //
// products/390/components/Frequent.vue